<template>
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 20.5a1 1 0 0 1-.5-.13C6.6 17.3 3.5 13.8 3.5 10.1 3.5 7.3 5.6 5 8.4 5c1.6 0 3 .8 3.6 2 .6-1.2 2-2 3.6-2 2.8 0 4.9 2.3 4.9 5.1 0 3.7-3.1 7.2-8 10.27a1 1 0 0 1-.5.13Z" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
</template>
